import styled from 'styled-components';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';

export const SelectCraneStyle = styled.div`
  margin-top: 62px;

  ${OnboardingStyle} {
    min-height: calc(100vh - 180px);
  }
`;
